import { useCallback } from "react";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { SiteControllerSettingAirHostFormModel } from "@/components/features/settings/site-controller/model/air-host/type";
import type { SiteControllerSettingAirHostFormModelMethodsType } from "@/components/features/settings/site-controller/model/air-host/use-case/use-create-model/methods";

import { InputTextFieldNew } from "@/components/ui/form/fields-new/input-field/input-text";

import type { ChangeEvent } from "react";

type Props = {
	airHostPropertyID: SiteControllerSettingAirHostFormModel["ViewModel"]["airHostSettings"]["airHostPropertyID"];
	onSetAirHostPropertyID: SiteControllerSettingAirHostFormModelMethodsType["onSetAirHostPropertyID"];
};

export const SettingsSiteControllerAirHostPropertyID = ({ airHostPropertyID, onSetAirHostPropertyID }: Props) => {
	const handleChangePropertyID = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			onSetAirHostPropertyID(event.target.value);
		},
		[onSetAirHostPropertyID],
	);

	return (
		<QuestionForMain
			required={true}
			title={"施設ID"}
			inputChildren={
				<InputTextFieldNew
					className="w-2/3 lg:w-1/2"
					value={airHostPropertyID.value}
					errorMessage={airHostPropertyID.error}
					onChange={handleChangePropertyID}
				/>
			}
		/>
	);
};

SettingsSiteControllerAirHostPropertyID.displayName = "SettingsSiteControllerAirHostPropertyID";
